import React from 'react';
import ContentLoader from 'react-content-loader';

const DepartmentAddLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={1463}
      height={950}
      viewBox="0 0 1463 950"
      backgroundColor="#c3d3f3"
      foregroundColor="#ecebed">
      <>
        <rect x="15" y="27" rx="3" ry="3" width="230" height="18" />

        <rect x="15" y="97" rx="3" ry="3" width="60" height="12" />
        <rect x="285" y="97" rx="3" ry="3" width="45" height="12" />
        <rect x="15" y="119" rx="3" ry="3" width="260" height="40" />
        <rect x="285" y="119" rx="3" ry="3" width="90" height="40" />

        <rect x="15" y="185" rx="3" ry="3" width="55" height="12" />
        <rect x="15" y="207" rx="3" ry="3" width="260" height="40" />

        <rect x="15" y="275" rx="3" ry="3" width="60" height="12" />
        <rect x="285" y="275" rx="3" ry="3" width="45" height="12" />
        <rect x="565" y="275" rx="3" ry="3" width="25" height="12" />
        <rect x="675" y="275" rx="3" ry="3" width="45" height="12" />
        <rect x="785" y="275" rx="3" ry="3" width="35" height="12" />
        <rect x="15" y="297" rx="3" ry="3" width="260" height="40" />
        <rect x="285" y="297" rx="3" ry="3" width="260" height="40" />
        <rect x="565" y="297" rx="3" ry="3" width="90" height="40" />
        <rect x="675" y="297" rx="3" ry="3" width="90" height="40" />
        <rect x="785" y="297" rx="3" ry="3" width="90" height="40" />

        <rect x="15" y="363" rx="3" ry="3" width="87" height="12" />
        <rect x="15" y="385" rx="3" ry="3" width="260" height="40" />

        <rect x="15" y="451" rx="3" ry="3" width="117" height="12" />
        <rect x="15" y="473" rx="3" ry="3" width="260" height="40" />

        <rect x="15" y="539" rx="3" ry="3" width="65" height="12" />
        <rect x="15" y="561" rx="3" ry="3" width="260" height="40" />

        <rect x="15" y="627" rx="3" ry="3" width="126" height="12" />
        <rect x="15" y="649" rx="3" ry="3" width="260" height="40" />

        <rect x="15" y="715" rx="3" ry="3" width="73" height="12" />
        <rect x="15" y="737" rx="3" ry="3" width="260" height="40" />

        <rect x="15" y="803" rx="3" ry="3" width="183" height="12" />
        <rect x="15" y="825" rx="3" ry="3" width="520" height="88" />
      </>
    </ContentLoader>
  );
};

export default DepartmentAddLoader;
